var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2147 1.04673C22.2308 0.525789 21.8442 0.0771243 21.3241 0.0431326C20.8864 0.014527 20.4449 0 20 0C16.9337 0 14.0286 0.690039 11.4314 1.9233C11.0215 2.11797 10.8126 2.57518 10.9131 3.01772L19.1657 39.3289C19.254 39.7176 19.5933 39.9998 19.9919 40C19.9946 40 19.9973 40 20 40C20.0027 40 20.0054 40 20.0081 40C20.0357 40 20.0633 39.9999 20.0909 39.9998C20.6119 39.9975 21.0252 39.5736 21.0413 39.0528L22.2147 1.04673Z",
    fill: "#4E3E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6784 33.5849C34.0991 34.2105 33.111 33.7795 33.1013 32.927L32.8043 6.77884C32.7946 5.92622 33.7728 5.47297 34.3661 6.08539C37.8535 9.68529 40 14.592 40 20C40 25.2447 37.9812 30.0179 34.6784 33.5849Z",
    fill: "#4E3E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25567 33.5133C5.90721 34.2238 6.94216 33.5852 6.69885 32.6524L2.20992 15.4428C1.96677 14.5106 0.753392 14.4584 0.532477 15.3961C0.184244 16.8742 0 18.4156 0 20C0 25.2097 1.99191 29.9541 5.25567 33.5133Z",
    fill: "#4E3E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.ffd8d4fa558bdfc5a2f45359ceadc983.svg";
export { ForwardRef as ReactComponent };